import { Component, OnInit } from '@angular/core';
import { constants } from '../constants';
import { CommonUtilitiesService } from "../common-utilities.service";
import { OrderHistoryService } from "./order-history.service";
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from "@angular/router";
import * as $ from 'jquery';

//jquery var
declare var $: any;

@Component({
  selector: 'app-order-history',
  templateUrl: './order-history.component.html',
  styleUrls: ['./order-history.component.scss']
})
export class OrderHistoryComponent implements OnInit {

  //Listado de lineas
  listLines = [];
  //Listado de tickets
  pendingTickets = [];
  pendingTicketsInmutable = [];
  //Bandera del loader
  isPendingTicketLoading = false;
  //formulario
  orderForm: FormGroup;
  allLinesConstant = constants.ALL_LINES_VALUE;
  //params
  isLastTicketShow = null;
  tablejs = null;
  isReload = false;

  constructor(public LANG: CommonUtilitiesService, private formbuilder: FormBuilder, private orderHistoryService: OrderHistoryService, private route: ActivatedRoute) {
    //obtener params
    this.route.params.subscribe(params => this.setLastDetailParam(params));
  }

  ngOnInit() {

    //validaciones de formulario
    this.orderForm = this.formbuilder.group({
      inputLines: ['', [Validators.required]],
    });

    let userData = JSON.parse(localStorage.getItem("userData"));
    for (var k in userData.associatedCellPhones) {
      this.listLines.push({ "id": userData.associatedCellPhones[k].id, "linea": userData.associatedCellPhones[k].id });
    }

    this.listLines = this.sortByKey(this.listLines, 'linea');

  }

 /**
  * Description: Método que ordena el arreglo de lineas
  * Autor: Diego Diaz
  * @param array listado de lineas
  * @param key atributo de ordenamiento
  * @return lista ordenada
 */
  sortByKey(array, key) {
      return array.sort(function(a, b) {
        var x = a[key]; var y = b[key];
        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
      });
  }


  /**
  * Description: Método que inicializa la tabla de historico de ordenes
  * Autor: Diego Diaz
  * @param N/A
  * @return N/A
 */
  tableInit() {
    var dataSet = this.pendingTickets;
    //datatable
    let noDataFoundText = this.LANG.getLangText('LABEL_NO_DATA_FOUND');
    var table = $('#orders-table').DataTable({
      autoWidth: false,
      lengthChange: false,
      pagingType: 'full_numbers',
      pageLengt: 5,
      info: false,
      ordering: false,
      data: dataSet,
      columns: [
        { title: this.LANG.getLangText('ORDER_HISTORY_LABEL_TABLE_DATE') },
        { title: this.LANG.getLangText('ORDER_HISTORY_LABEL_TABLE_NUM_TICKET') },
        { title: this.LANG.getLangText('ORDER_HISTORY_LABEL_TABLE_DETAIL') },
        { title: this.LANG.getLangText('ORDER_HISTORY_LABEL_TABLE_STATE') }
      ],
      language: {
        paginate: {
          first: '«',
          previous: '‹',
          next: '›',
          last: '»'
        },
        emptyTable: noDataFoundText
      }
    });

    this.tablejs = table;
    let _self = this;
    $('#orders-table thead tr').clone(true).appendTo('#orders-table thead');
    $('#orders-table thead tr:eq(1) th').each(function (i) {
      var title = $(this).text();
      $(this).html('<input type="text" id="search_'+i+'" class="w-100" placeholder="Buscar" />');
      $('input', this).on('keyup change', function () {
        _self.pendingTickets = [];
        for (var k in _self.pendingTicketsInmutable) {         
          if ((_self.pendingTicketsInmutable[k][i]).toLowerCase().includes(this.value.toLowerCase())) {
            _self.pendingTickets.push(_self.pendingTicketsInmutable[k]);
          }
        }
        _self.setTicketListSelf(_self.pendingTickets, table);

      });
    });
  }


  /**
  * Description: Método que refresca la información de la tabla al filtrar info
  * Autor: Diego Diaz
  * @param _selfList datos nuevos
  * @param table tabla de registros
  * @return N/A
 */
  setTicketListSelf(_selfList, table) {
    this.pendingTickets = _selfList;
    table.clear().rows.add(this.pendingTickets).draw()
  }

  /**
  * Description: Método que obtiene el id del ticket a mostrar en caso de queret ver detalle del ticket
  * Autor: Diego Diaz
  * @param params parametros de url
  * @return N/A
 */
  setLastDetailParam(params) {
    this.isLastTicketShow = params.isLast;
    if (this.isLastTicketShow == constants.ROUTE_URL_PARAM_TICKET_DETAIL) {
      this.searchTicketList();
    } else {
      this.isLastTicketShow = null;
    }
  }

  /**
   * Description: Método que obtiene la lista de tickets segun la linea seleccionada
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
  */
  searchTicketList() {
    //se obtiene la infor de sesión
    this.pendingTickets = [];
    let userData = JSON.parse(localStorage.getItem("userData"));
    this.isPendingTicketLoading = true;
    this.orderHistoryService.getPendingTickets(userData.customerAccountId).subscribe((data => {
      this.isPendingTicketLoading = false;
      if (data['responseCode'] == constants.SUCCESS_WS_RESPONSE_CODE) {
        let phone = this.removeZero(this.orderForm.get('inputLines').value);

        let auxList = data['obj'];
        data['obj'] = auxList.reverse();
        let auxObj = [];
        for (var k in data['obj']) {
          if (data['obj'][k].phoneLineAffected == phone || phone == constants.ALL_LINES_VALUE) {
            auxObj = [this.formatDate(data['obj'][k].dateCreated), data['obj'][k].ticketId, data['obj'][k].categorizationTier1, data['obj'][k].status];
            this.pendingTickets.push(auxObj);
          }
        }

        //HU: Detalle ticket
        if (this.isLastTicketShow != null) {
          this.pendingTickets = [];
          if (data['obj'].length > 0) {
            auxObj = [this.formatDate(data['obj'][0].dateCreated), data['obj'][0].ticketId, data['obj'][0].categorizationTier1, data['obj'][0].status];
            this.pendingTickets.push(auxObj);            
            $(function() {
              $("#inputLines").val('0' + data['obj'][0].phoneLineAffected);
            });
          }
          this.isLastTicketShow = null;
        }

        this.pendingTicketsInmutable = this.pendingTickets;

        if(this.isReload){
          this.setTicketListSelf(this.pendingTickets,this.tablejs);
        }else{
          this.isReload = true;
          this.tableInit();
        }      
        
      }else{
        if(this.isReload){
          this.setTicketListSelf(this.pendingTickets,this.tablejs);
        }else{
          this.isReload = true;
          this.tableInit();
        }  
      }
    }),
      (err) => {
        this.isPendingTicketLoading = false;
        this.pendingTickets = [];
      });
  }

  /**
  * Description: Método que da formato a la fecha para mostrar en pantalla
  * Autor: Diego Diaz
  * @param dateStr fecha con formato de bd
  * @return fecha con formato dd/mm/yyyy
 */
  formatDate(dateStr) {
    let dateArray = dateStr.split("T");
    dateArray = dateArray[0].split("-");
    return dateArray[2] + "/" + dateArray[1] + "/" + dateArray[0];
  }
  
       /**
   * Description: Método que remueve el numero 0 inicial
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
   */
  removeZero(phone){
    var auxPhone = phone;
    if(phone.charAt(0) == '0'){
      auxPhone = phone.substr(1);
    }    
    return auxPhone;
  }
}
